import React from 'react';
import MenuPainel from '../components/MenuPainel';
import AdmAcionamento from '../components/AcionamentoVonage';
import { ChangePassword } from '../components/ChangePassword';
import PaperForm from '../components/PaperForm';
import GlobalStyle from '../styles/globalStyle';
import { CssBaseline } from '@material-ui/core';

class AcionamentoVonage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <GlobalStyle />
        <ChangePassword />
        <MenuPainel stepper='Acionamento Manual Vonage'>
          <PaperForm
            title={''}
            margin={'15px 0'}
            elevation={24}
            componente={<AdmAcionamento />}
          ></PaperForm>
        </MenuPainel>
      </React.Fragment>
    );
  }
}

const connectedAssinar = AcionamentoVonage;
export { connectedAssinar as AcionamentoVonage };
